import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import AuthProvider from "./context/AuthContext";
import ScreenSizeProvider from "./context/ScreenSizeContext";
import "bootstrap/dist/css/bootstrap.css";

ReactDOM.render(
  <React.StrictMode>
    <AuthProvider>
      <ScreenSizeProvider>
        <App />
      </ScreenSizeProvider>
    </AuthProvider>
  </React.StrictMode>,
  document.getElementById("root")
);
